import { DrawerSection } from '@components/ui/drawer/section';
import { SchedulerSidebarEquipmentMember } from './member';
import { SchedulerSidebarEquipmentMultiSelect } from './multiSelect';
import { useTranslation } from 'react-i18next';
import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { useDropdownsContext } from '@contexts/dropdowns';
import { useSchedulerContext } from '@contexts/scheduler';
import { isManuallyAdded } from './helpers';
import { cn } from '@utils/cn';
import { useAccess } from '@hooks/access';

export type SchedulerSidebarEquipmentProps = {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
};

export const SchedulerSidebarEquipment = ({
  expanded,
  onExpandedChange,
}: SchedulerSidebarEquipmentProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'schedule.equipment' });

  const { equipmentMembers, disabled } = useSchedulerSidebar();
  const access = useAccess();
  const {
    active: { schedule },
  } = useSchedulerContext();
  const { fieldUsers } = useDropdownsContext();

  const isEditingEquipment = equipmentMembers.some((el) => el.edit);

  const equipmentMembersWithManuallyAddedInfo = equipmentMembers.map((el) => ({
    ...el,
    manuallyAdded: isManuallyAdded(el.assetId, schedule.foreman?.id, fieldUsers),
  }));

  return (
    <DrawerSection
      title={t('title', { count: equipmentMembers.length })}
      titleClassName="text-xs font-semibold"
      disabled={disabled}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      className={cn('flex flex-col border-t-0 p-2', expanded && 'h-full min-h-0 overflow-hidden')}>
      <div className="flex min-h-0 flex-1 flex-col gap-2">
        {!access.readOnly && (
          <SchedulerSidebarEquipmentMultiSelect disabled={disabled || isEditingEquipment} />
        )}
        <div className="scrollbar-thin min-h-0 flex-1 overflow-y-auto">
          <div className="grid grid-cols-[34px_auto_34px_34px] items-center gap-y-2">
            {equipmentMembersWithManuallyAddedInfo.map((el) => (
              <SchedulerSidebarEquipmentMember key={el.assetId} data={el} />
            ))}
          </div>
        </div>
      </div>
    </DrawerSection>
  );
};
